// import TagManager from "react-gtm-module";
import * as RudderAnalytics from "rudder-sdk-js"; // TagManager.initialize({
//   gtmId: process.env.GA_ID,
// });

RudderAnalytics.ready(null);
RudderAnalytics.load(process.env.ANALYTICS_WRITE_KEY, process.env.ANALYTICS_DATA_PLANE_URL);
/*
// WATCHOUT between productID and variantID
// DONE: PageView
// DONE: CategoryView
// DONE: CategoryFilter
// DONE: ProductView
// DONE: AddToCart
// DONE: RemovedFromCart
// DONE: Checkout including steps
// TODO: Checkout include Trait to trigger CartAbandonment
// DONE: Review
// DONE: AddToWishList
// DONE: RemovedFromWishList
// DONE: AddToCartFromWishlist
// DONE: SaveByEmail
// TODO: ProductConfigurator
// DONE: IndentifyTheUser SignIn
// DONE: IndentifyTheUser AutoSignIn
// DONE: IndentifyTheUser SignOut

// TODO: Clean the molecule -- CartSummaryRow

// NEED
// Ensure that on all ecommerce events have those minimum information passed
//    {
//       'name': 'the product name',
//       'id': 'the product_id not the variant_id',
//       'category': 'the product category',
//       'variant': 'the variant_id or the selectedattributes to be decided',
//     }

*/

export { RudderAnalytics };